﻿(function ($) {
    (function () {
        //prevent setting focus back in dialog if currently focused ko-inline-popup (even if it's located outside of dialog)

        var original = $.ui.dialog.prototype._allowInteraction;
        $.ui.dialog.prototype._allowInteraction = function (event) {
            return original.apply(this, arguments) || $(event.target).closest(".ko-inline-popup").length;
        };

        $.ui.dialog.prototype.setOpener = function ($el) {
            this.opener = $el;
        };

    })();

    //add abillity to specify class for jquery datepicker calendar via calendarClass option
    (function() {

        var getDatepickerScrollableContainer = function (input, inst) {
            if (inst && inst.settings && inst.settings.appendToBody) {
                return null;
            }

            var $scrollableContainer = $(input).parents(":ep-scrollable").first();
            if ($scrollableContainer.length && !$scrollableContainer.is("body")) {
                return $scrollableContainer;
            }

            return null;
        };

        var isDatepickerInScrollableInnerContainer = function (input, inst) {
            var container = getDatepickerScrollableContainer(input, inst);
            return container && container.length > 0;
        };

        const adjustDatepickerPlacement = function (input, inst) {
            var $container = getDatepickerScrollableContainer(input, inst);
            if ($container && inst.dpDiv.parent().is("body")) {
                inst.dpDiv.appendTo($container);
            } else if (!$container && !inst.dpDiv.parent().is("body")) {
                inst.dpDiv.appendTo($("body"));
            }
        };

        var original = $.fn.datepicker;
        $.fn.datepicker = function(options) {
            var args = Array.prototype.slice.call(arguments);
            if (!options || typeof options !== 'string') {
                options = $.extend({ showAnim: false }, options);

                var beforeShow = options.beforeShow;
                options.beforeShow = function (input, datepicker) {
                    var $container = getDatepickerScrollableContainer(input, datepicker);
                    if ($container) {
                        datepicker.dpDiv.appendTo($container);
                    }

                    if (options.calendarClass) {
                        datepicker.dpDiv.addClass(options.calendarClass);
                    }

                    if (beforeShow) {
                        return beforeShow.apply(this, arguments);
                    }
                };

                var onClose = options.onClose;
                options.onClose = function (input, datepicker) {
                    if (isDatepickerInScrollableInnerContainer(this, datepicker)) {
                        datepicker.dpDiv.hide().appendTo($("body"));
                        datepicker.dpDiv.removeClass("ep-datepicker-not-fixed");
                    }

                    if (options.calendarClass) {
                        datepicker.dpDiv.removeClass(options.calendarClass);
                    }

                    if (onClose) {
                        onClose.apply(this, arguments);
                    }
                };

                args[0] = options;
            }

            // additionally check if we need hide datepicker when
            // mousedown event propagation was stopped via epStopPropagation
            // it's case for datepickers inside ko.bindings.inlinePopup when user clicks somewhere 
            // inside inline popup and datepicker is opened (e.g. myassignments -> save timer's timelog popup)
            if(this.length && !$.datepicker.initialized){
                $(document).on("epclickstopped", function(e, data){
                    if(data && data.originalType === "mousedown"){
                        $.datepicker._checkExternalClick.apply(this, arguments);
                    }
                });
            }
            return original.apply(this, args);
        };

        var _doKeyDownOrig = $.datepicker._doKeyDown;
        $.datepicker._doKeyDown = function (event) {
            if (event.which === ep.Keys.enter) {
                var inst = $.datepicker._getInst(event.target)
                if (inst && inst.settings.doKeyEnter) {
                    return inst.settings.doKeyEnter(event);
                }

                // fix problem when keydown enter and datepicker not validate value correct
                // Now when datepicker open and we push enter button, Date not change to default date
                // When put button enter close datapicker
                $.datepicker._hideDatepicker();
                return;
            }

            _doKeyDownOrig.call(this, event);
        };

        var checkOffsetOriginal = $.datepicker._checkOffset;
        $.datepicker._checkOffset = function (inst, offset, isFixed) {
            var $scrollableContainer = getDatepickerScrollableContainer(inst.input, inst);
            if ($scrollableContainer) {

                var fixedContainer = isFixed && inst.input.parentsUntil($scrollableContainer).filter(function () {
                    return $(this).css("position") === 'fixed';
                });

                if (isFixed && !fixedContainer.length) {
                    isFixed = !isFixed;
                    inst.dpDiv.addClass("ep-datepicker-not-fixed");
                }

                if (!isFixed) {
                    var viewPort = $scrollableContainer[0],
                    $viewPort = $scrollableContainer;

                    var dpWidth = inst.dpDiv.outerWidth(),
                    dpHeight = inst.dpDiv.outerHeight(),
                    inputWidth = inst.input ? inst.input.outerWidth() : 0,
                    inputHeight = inst.input ? inst.input.outerHeight() : 0,
                    viewWidth = viewPort.clientWidth + (isFixed ? 0 : $viewPort.scrollLeft()),
                    viewHeight = viewPort.clientHeight + (isFixed ? 0 : $viewPort.scrollTop());

                    offset.left -= (this._get(inst, "isRTL") ? (dpWidth - inputWidth) : 0);
                    offset.left -= (isFixed && offset.left === inst.input.offset().left) ? $(document).scrollLeft() : 0;
                    offset.top -= (isFixed && offset.top === (inst.input.offset().top + inputHeight)) ? $(document).scrollTop() : 0;

                    offset.top += $viewPort.scrollTop();
                    offset.top -= $viewPort.offset().top;
                    offset.left += $viewPort.scrollLeft();
                    offset.left -= $viewPort.offset().left;

                    // now check if datepicker is showing outside window viewport - move to a better place if so.
                    offset.left -= Math.min(offset.left, (offset.left + dpWidth > viewWidth && viewWidth > dpWidth) ?
                        Math.abs(offset.left + dpWidth - viewWidth) : 0);
                    offset.top -= Math.min(offset.top, (offset.top + dpHeight > viewHeight && viewHeight > dpHeight) ?
                        Math.abs(dpHeight + inputHeight) : 0);

                    return offset;
                }
            }

            return checkOffsetOriginal.apply(this, arguments);
        };

        $.datepicker._updatePositionDatepicker = function(input) {
            if ($.datepicker._lastInput !== input) {
                return;
            }
            var inst = $.datepicker._getInst(input);
            if (inst) {
                adjustDatepickerPlacement(input, inst);

                $.datepicker._pos = $.datepicker._findPos(input);
                $.datepicker._pos[1] += input.offsetHeight; // add the height

                var isFixed = false;
                $(input).parents().each(function() {
                    isFixed |= $(this).css("position") === "fixed";
                    return !isFixed;
                });

                var offset = { left: $.datepicker._pos[0], top: $.datepicker._pos[1] };
                $.datepicker._pos = null;

                offset = $.datepicker._checkOffset(inst, offset, isFixed);
                inst.dpDiv.css({ left: offset.left + "px", top: offset.top + "px" });
            }
        };

        (function() {
            var original = $.datepicker._optionDatepicker;
            /*
                Fixes for #27688 "Date piker works incorrectly"
                We have a lot of places in system where two datepickers should be synced
                For example we set min date for end date when we change start date

                Unfortunately original sources of datepicker always redraws calendar
                 when options are changed (or new date is set), even if currently calendar
                 is opened for another datepicker (_currInst). After this redraw calendar is
                 attached to updated datepicker input (even if position is not changed).

               So we mostly copied original sources with one change -> update calendar only
               if updating instance is currently opened instance, otherwise just save new options
               and they will be applied if user opens calendar for this input later.
             */

            $.datepicker._setDateDatepicker = function (target, date) {
                var inst = this._getInst( target );
                if ( inst ) {
                    this._setDate(inst, date);
                    if (this._curInst === inst) {
                        this._updateDatepicker(inst);
                        this._updateAlternate(inst);
                    }
                }
            };

            $.datepicker._optionDatepicker = function(target, name, value) {
                var inst = this._getInst(target);
                if (this._curInst && this._curInst !== inst && arguments.length === 3) {
                    var settings = {}, date, minDate, maxDate;

                    settings[name] = value;

                    if (inst) {
                        if (this._curInst === inst) {
                            this._hideDatepicker();
                        }

                        date = this._getDateDatepicker(target, true);
                        minDate = this._getMinMaxDate(inst, "min");
                        maxDate = this._getMinMaxDate(inst, "max");
                        datepicker_extendRemove(inst.settings, settings);
                        // reformat the old minDate/maxDate values if dateFormat changes and a new minDate/maxDate isn't provided
                        if (minDate !== null && settings.dateFormat !== undefined && settings.minDate === undefined) {
                            inst.settings.minDate = this._formatDate(inst, minDate);
                        }
                        if (maxDate !== null && settings.dateFormat !== undefined && settings.maxDate === undefined) {
                            inst.settings.maxDate = this._formatDate(inst, maxDate);
                        }
                        if ("disabled" in settings) {
                            if (settings.disabled) {
                                this._disableDatepicker(target);
                            } else {
                                this._enableDatepicker(target);
                            }
                        }
                        this._setDate(inst, date);
                    }
                } else {
                    return original.apply(this, arguments);
                }
            };

            /* jQuery extend now ignores nulls! */
            function datepicker_extendRemove(target, props) {
                $.extend(target, props);
                for (var name in props) {
                    if (props[name] == null) {
                        target[name] = props[name];
                    }
                }
                return target;
            }
        })();

    })();

    $.fn.epDestroyDatepicker = function(){
        this.each(function(){
            var $el = $(this);
            $el.datepicker("hide");
            $el.datepicker("destroy");
        });
        return this;
    };

    (function(){
        $.fn.epUpdateDlgPosition = function(){
            this.each(function(){
                var $el = $(this);
                if ($el.is(":ui-dialog") && $el.dialog("isOpen")) {
                    var position = $el.dialog("option", "position");
                    $el.dialog("option", "position", position);
                }
            });
            return this;
        };
    })();

})(jQuery);
